import React, { useEffect, useState } from 'react';
import './Orders.css';
import { liveServerUrl, serverUrl } from '../../../Shared/constant';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';




const Orders = () => {
    const [orderUsers, setOrderUsers] = useState([])

    useEffect(() => {
        fetch(`${liveServerUrl}/api/mosollaLanding`)
            .then((response) => response.json())
            .then((result) => {
                setOrderUsers(result);
            })
            .catch((error) => console.error("Error:", error));
    }, []);



    const acceptOrder = (orderId) => {

        window.confirm(orderId)
    }

    const navigate = useNavigate();

    const getValue = (val) => {
        // or innerHTML
        console.log(val)
        navigate(`orders/${val}`)
    };


    const acceptDelete = async (orderId) => {

        const finalOk = window.confirm('are u sure to delete?')


        if (finalOk) {

            try {
                const res = await fetch(`${liveServerUrl}/api/mosollaLanding/${orderId}`, {
                    method: "DELETE",
                });

                if (res.ok) {
                    setOrderUsers(orderUsers.filter(user => user._id !== orderId));
                    toast.success("Deleted successfully");
                } else {
                    toast.error("Delete failed");
                }
            } catch (err) {
                toast.error("Error occurred");
            }
        }









    }





    return (
        <div>
            <p className='orderHeading'>Your upcoming orders</p>
            <section className='orderPendingNav'>
                <div>
                    <p>order id</p>
                </div>
                <div>
                    <p>products</p>
                </div>
                <div>
                    <p>customer name</p>
                </div>
                <div>
                    <p>contact</p>
                </div>
                <div>
                    <p>quantity</p>
                </div>
                <div>
                    <p>price</p>
                </div>
                <div>
                    <p>order status</p>
                </div>
                <div>
                    <p>action</p>
                </div>
                <div>
                    <p>Accept order</p>
                </div>
            </section>


            {
                orderUsers.map((orderUser) => (
                    <section className='orderPendingDetails'>
                        <div>
                            <p onClick={() => getValue(orderUser._id)}><Link to=''> #DAF{orderUser._id.slice(0, 8)}</Link>

                            </p>
                        </div>
                        <div>
                            <p>{orderUser?.productTitle.slice(0, 25)}</p>
                        </div>
                        <div>
                            <p>{orderUser?.name}</p>
                        </div>
                        <div>
                            <p>{orderUser.phone}</p>
                        </div>
                        <div>
                            <p>1</p>
                        </div>
                        <div>
                            <p>{orderUser?.total}</p>
                        </div>
                        <div>
                            <p>Pending</p>
                        </div>
                        <div >
                            <button onClick={() => acceptDelete(orderUser._id)}>Delete</button>
                        </div>
                        <div style={{ display: 'flex', justifyContent: "center" }} onClick={() => acceptOrder(orderUser._id)}>
                            <p className='orderSelect'>accept</p>
                        </div>
                    </section>
                ))
            }

            <ToastContainer />
            <br /><br /><br /><br /><br />
        </div>
    );
};

export default Orders;